import React from 'react';
import Select from 'react-select';
import '../../../stylesheets/lis-public-view/public-view.css';
import moment from 'moment-timezone';
import { AccessibleDatePicker } from '../../../lis-shared/lis-layout/components/lis-forms-component';

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            selectedMember: '',
            selectedSubject: '',
            selectedDate: null,
            isSubjectMenuOpen: false,
            isMemberMenuOpen: false
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleMemberDropdownChange = this.handleMemberDropdownChange.bind(this);
        this.handleSubjectDropdownChange = this.handleSubjectDropdownChange.bind(this);
    }

    handleMemberDropdownChange(val) {
        this.setState({
            selectedMember: val
        }, () => {
            //The next step is done after the state change to make sure the user sees what member was selected before going to the advanced search page
            let param = {
                selectedPatron: this.state.selectedMember.MemberID,
                selectedSession: this.props.sessionList.find(s => s.SessionCode === this.props.session),
                chamberCode: this.state.selectedMember.ChamberCode,
                selectedPatronType: [1],
                includeFailed: true
            }

            const link = window.btoa(JSON.stringify(param));
            this.props.history.push('/bill-search?q=' + link);

        });
    }

    handleSubjectDropdownChange(val) {
        this.setState({
            selectedSubject: val
        }, () => {
            //The next step is done after the state change to make sure the user sees what member was selected before going to the advanced search page
            const param = {
                selectedSubject: this.state.selectedSubject.SubjectIndexID,
                selectedSession: this.props.sessionList.find(s => s.SessionCode === this.props.session),
                includeFailed: true
            }
            const link = window.btoa(JSON.stringify(param));
            this.props.history.push('/bill-search?q=' + link);
        });
    }

    handleDateChange(val) {
        this.setState({
            selectedDate: val
        }, () => {
            const introDate = this.state.selectedDate.clone();
            introDate.hour(0);
            const param = {
                introductionDate: introDate,
                includeFailed: true
            };
            const link = window.btoa(JSON.stringify(param));
            this.props.history.push('/bill-search?q=' + link);
        });
    }

    render() {
        const customStyles = {
            container: base => ({
                ...base,
                lineHeight: 'normal',
                width: '100%',
            }),
            option: (base, state) => ({
                ...base,
                fontSize: '0.8em',
            }),
            control: (base) => ({
                ...base,
                padding: '1px',
                margin: 0,
                minHeight: 0,
                fontSize: '0.8em',
                borderColor: "#949494"
            }),
            dropdownIndicator: base => ({
                ...base,
                padding: '0px 8px',
                color: "#666666"
            }),
            indicatorSeparator: (base) => ({
                ...base,
                display: "none"
            }),
            menu: (base) => ({
                ...base,
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                wordBreak: 'break-word'
            }),
            clearIndicator: (base) => ({
                ...base,
                color: "#666666"
            }),
        };
        const memberList = [...this.props.memberList]
        memberList.forEach((member) => {
            member.label = "(" + member.ChamberCode + ") " + member.ListDisplayName;
            member.value = member.MemberID;
        });
        let datesList = [];
        this.props.datesList.forEach(date => datesList.push(moment(date.IntroductionDate).tz('America/New_York')));
        // Why have today's date, always ...
        const openToDate = datesList[datesList.length - 1];

        const handleSelectEnterKey = (e, isMenuOpen) => {
            if (e.key === 'Enter' && !isMenuOpen) {
                e.preventDefault();
                const arrowDownEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    code: 'ArrowDown',
                    keyCode: 40,
                    which: 40,
                    bubbles: true
                });
                e.currentTarget.dispatchEvent(arrowDownEvent);
            }
        }
        
        return (
            <div className="dlas-forms home-search-section">
                <br />
                <div id="search-selectors">
                    <div className="selector">
                        <div className="subject">
                            <label htmlFor="bills-by-subject" className="search-option-label">Bills by Subject</label>
                            <Select
                                aria-label="Subject Selector"
                                id="bills-by-subject"
                                styles={customStyles}
                                isDisabled={!this.props.isLoaded}
                                options={this.props.subjectList}
                                onKeyDown={(e) => handleSelectEnterKey(e, this.state.isSubjectMenuOpen)}
                                onMenuOpen={() => this.setState({ isSubjectMenuOpen: true })}
                                onMenuClose={() => this.setState({ isSubjectMenuOpen: false })}
                                value={this.state.selectedSubject}
                                onChange={this.handleSubjectDropdownChange}
                            />
                        </div>
                    </div>
                    <div className="selector">
                        <div className="member">
                            <label htmlFor="bills-by-member" className="search-option-label">Bills by Member</label>
                            <Select
                                aria-label="Member Selector"
                                id="bills-by-member"
                                styles={customStyles}
                                isDisabled={!this.props.isLoaded}
                                options={memberList}
                                onKeyDown={(e) => handleSelectEnterKey(e, this.state.isMemberMenuOpen)}
                                onMenuOpen={() => this.setState({ isMemberMenuOpen: true })}
                                onMenuClose={() => this.setState({ isMemberMenuOpen: false })}
                                onChange={this.handleMemberDropdownChange}
                                value={this.state.selectedMember}                                
                            />
                        </div>
                    </div>
                    <div className="selector">
                        <div className="introduced">
                            <label htmlFor="bills-by-date" className="search-option-label">Bills Introduced by Day</label>
                            <AccessibleDatePicker
                                id="bills-by-date"
                                disabled={!this.props.isLoaded || !openToDate}
                                selected={this.state.selectedDate}
                                onChange={this.handleDateChange}
                                includeDates={datesList}
                                openToDate={openToDate}
                            />
                        </div>
                    </div>
                </div>
                <hr />
            </div>

        )
    }
}

export default Search
